module.exports = __webpack_public_path__ + "static/usain-bolt-958-84d0b9f8c618c968841e8e382e3fbf8c.jpg";